export const DEBOUNCER_DELAY = 1000;
